export default "__VITE_ASSET__DWx_324d__"